import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { AccesoGuard } from './guard/acceso.guard';
import { CardsComponent } from './views/base/cards.component';
import { CalidadComponent } from './views/component/calidad/calidad.component';
import { CatalogoComponent } from './views/component/catalogo/catalogo.component';
import { ConfigetiquetaComponent } from './views/component/configetiqueta/configetiqueta.component';
import { CrecimientoComponent } from './views/component/crecimiento/crecimiento.component';
import { GestionadminComponent } from './views/component/gestionadmin/gestionadmin.component';
import { HojaLocalesComponent } from './views/component/hoja-locales/hoja-locales.component';
import { HojaComponent } from './views/component/hoja/hoja.component';
import { HomologacionComponent } from './views/component/homologacion/homologacion.component';
import { ManualComponent } from './views/component/manual/manual.component';
import { MetaLocalComponent } from './views/component/meta-local/meta-local.component';
import { OrdenesComponent } from './views/component/ordenes/ordenes.component';
import { PublicidadComponent } from './views/component/publicidad/publicidad.component';
import { ReportDevolucionxLocalComponent } from './views/component/report-devolucionx-local/report-devolucionx-local.component';
import { ReportMetaComponent } from './views/component/report-meta/report-meta.component';
import { ReportRakingxLocalComponent } from './views/component/report-rakingx-local/report-rakingx-local.component';
import { ReportVentasxLocalComponent } from './views/component/report-ventasx-local/report-ventasx-local.component';
import { ReporteCrecimientoComponent } from './views/component/reporte-crecimiento/reporte-crecimiento.component';
import { UsuarioComponent } from './views/component/usuario/usuario.component';
import { DashboardReporteComponent } from './views/dashboard_reporte/dashboardReporte.component';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
    canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['MaxiPan','local'],
        //redirectTo: '/unidades'
      }
    }
  },
  {
    path: '404',
    canActivate: [AccesoGuard],
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    canActivate: [AccesoGuard],
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AccesoGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },
      {
      
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      },

      {
        
        path: 'reporte', canLoad: [AccesoGuard],
        component: DashboardReporteComponent,
        data: {
          title: 'REPORTES',
          permissions: {
            only: [],
            //redirectTo: '/unidades'
          }
        }
      },
       
     {
        path: 'hoja', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: HojaComponent,
        data: {
          title: 'GUIA PRODUCCION',
          permissions: {
            only: ['MaxiPan'],
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'usuario', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: UsuarioComponent,
        data: {
          title: 'USUARIOS',
          permissions: {
            only: ['MaxiPan'],
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'hojalocal', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: HojaLocalesComponent,
        data: {
          title: 'GUIA DE PRODUCCION',
          permissions: {
            only: ['local'],
            redirectTo: '/login'
          }
        }
      },
      {
        path: 'catalogo', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: CatalogoComponent,
        data: {
          title: 'Catalo de Producto',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },

      
      {
        path: 'publicidad', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: PublicidadComponent,
        data: {
          title: 'Publicidad',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },

      {
        path: 'manual', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: ManualComponent,
        data: {
          title: 'Manual',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      }


      ,

      {
        path: 'gestionadmin', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: GestionadminComponent,
        data: {
          title: 'Crecimiento Administrador',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },


      {
        path: 'gestion', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: CrecimientoComponent,
        data: {
          title: 'Gestion',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },
      
      {
        path: 'ventas-local', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: ReportVentasxLocalComponent,
        data: {
          title: 'VENTAS POR LOCAL',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },
      {
        path: 'rankig-local', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: ReportRakingxLocalComponent,
        data: {
          title: 'RANKING POR LOCAL',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },
      {
        path: 'devolucion-local', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: ReportDevolucionxLocalComponent,
        data: {
          title: 'DEVOLUCION POR PRODUCTO',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },
      {
        path: 'meta-reporte', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: ReportMetaComponent,
        data: {
          title: 'REPORTE METAS POR LOCAL',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },
      {
        path: 'reporte-crecimiento', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: ReporteCrecimientoComponent,
        data: {
          title: 'REPORTE CRECIMIENTO VS DEVOLUCION',
          permissions: {
            only: ['local','MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },
      {
        path: 'meta-local', canLoad: [AccesoGuard], canActivate: [NgxPermissionsGuard],
        component: MetaLocalComponent,
        data: {
          title: 'REGISTRO METAS POR LOCAL',
          permissions: {
            only: ['MaxiPan','Administrador CF'],
            redirectTo: '/login'
          }
        }
      },
      
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
